import { useDispatch, useSelector } from 'react-redux';
import { ScrollView } from 'react-native-gesture-handler';
import React, { Fragment, useEffect, useState } from 'react';
import { Image, ImageBackground, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Typography } from '../tds/style';
import { COLORS } from '../../constants/colorPallete';
import NoDataNotification from '../NoDataFound/noData';
import getPlatformType, { getImage } from '../../helpers/getPlatform';
import { CardBig, CardContainer, RowContainer } from './styles';
import { STRIPEKEY } from '../../helpers/connectionHelpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import { ButtonWrapper, TabHeadingText, TableLabes } from '../rentalPortal/styles';
import {
  getCreditLadderHistory,
  getLadger,
  getlink,
  startPayment,
  cancelSubscription,
  getPaymentStatus,
  updatePayment,
  getLadgerHistory,
  cancelRewardSubscription,
  activateFreeCLPlan
} from '../../redux/actions/Ladger';
import { Elements } from '@stripe/react-stripe-js';
import { CheckoutForm } from '../../components/idVerification/checkoutForm';
import CustomPopUp from '../../commonComponents/customPopUp/customPopUp';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton';
import { replaceAction } from '../../helpers/navigationHelpers';
import { getTokens } from '../../../openbrix-design-system/design-tokens/color-tokens';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { Wrapper } from '../identifyAndFinance/style';
import moment from 'moment';
import { getServerURL } from '../../helpers/functionHelpers';
import { ODSIcon } from '../../../openbrix-design-system/ui/atoms/ODSIcon';
import { useFocusEffect, useRoute } from '@react-navigation/native';
import PlanCard, { getItemColor } from '../../../openbrix-design-system/ui/atoms/ODSPlanCard';
import { getSubscriptionPlans } from '../../redux/actions/auth';
import { buttonPressEvent } from '../../helpers/analytics';
import { color } from 'react-native-reanimated';
import { types } from '../../redux/actionTypes';

// const tlyfePremiumObj={
//   "id": "tlyfe-premium",
//   "title": "tlyfe Premium",
//   "price": "5.99",
//   "originalPrice": "8",
//   "priceUnit": "/mo",
//   "promoLabel": "ONE TIME OFFER!",
//   "features": [
//       {
//           "text": "Everything in Extra"
//       },
//       {
//           "text": "Credit Builder service"
//       },
//       {
//           "text": "Credit score monitoring"
//       },
//       {
//           "text": "Rent reporting to credit agencies"
//       }
//   ],
//   "image": "https://assets.openbrix.co.uk/property-images-13vGi-1754486629574-1.png",
//   "isPopular": true,
//   "buttonColor": "#6dffb9"
// }

const MoreInformation = (props) => {
  const themeObj = getTokens('light').colors;
  const dispatch = useDispatch();
  const [url, setUrl] = useState('');
  const layoutType = getPlatformType();
  const isVerified = clhData ? true : false;
  const Paymentcol = ['Date', 'Amount', 'Post Code'];
  const [clientSecret, setClientSecret] = useState('');
  const [showCheckOutForm, setShowCheckOutForm] = useState(false);
  const [currentPlanName, setCurrentPlanName] = useState(null);

  const [paymentStatus, setPaymentStatus] = useState(null);
  const profile = useSelector((state) => state.authReducer.profile);
  const clhData = useSelector((state) => state.ladgerReducer.clhData);
  const subscription = useSelector((state) => state.ladgerReducer?.clhData?.subscription);
  const authDataFromMobile = useSelector((state) => state?.appReducer?.mobileData?.data?.isWebView);
  const [popUpIsVisible, setpopUpIsVisible] = useState(false);
  let stripePromise = loadStripe(STRIPEKEY);
  const route = useRoute();
  const isMobilePaymentRequire = useSelector(
    (state) => state?.mobileReducer?.isCreditBuilderPayment
  );
  // const [plans, setPlans] = useState({});
  const [tlyfePremiumObj, setTlyfePremiumObj] = useState(null);

  const isInappWebView = useSelector((state) => state?.mobileReducer?.isInappWebView);

  const [paymentRec, setPaymentRec] = useState(null);
  const paymentData = useSelector((state) => state.ladgerReducer?.clhData?.payment_data?.tenancies);
  const [planActivatedSuccess, setPlanActivatedSuccess] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  useFocusEffect(
    React.useCallback(() => {
      if (route.params?.refresh) {
        loadData();
      }
    }, [route.params?.refresh])
  );
  const loadData = () => {
    // dispatch(getLadger({}, props.navigation.navigate));
    dispatch(
      getlink((data) => {
        setUrl(data);
      })
    );
    dispatch(getCreditLadderHistory({}, props.navigation.navigate));
  };
  useEffect(() => {
    buttonPressEvent("Credit Builder", "Dashboard");
    dispatch(
      getSubscriptionPlans(false, (data) => {
        const fetchedPlans = data.plans;
        const tlyfePremiumPlan = fetchedPlans.filter(
          (plan) => plan.id === 'tlyfe-premium'
        );
        console.log('tlyfePremiumPlan:', tlyfePremiumPlan);
        setTlyfePremiumObj(tlyfePremiumPlan[0]);
        const currentPlanId = data.currentPlanId;
        setCurrentPlanName(currentPlanId);
      })
    );
    loadData();
  }, []);
  useEffect(() => {
    if (paymentData) {
      setPaymentRec(paymentData);
    }
  }, [paymentData]);
  const openLinkCreditHoistory = () => {
    window.open(url, '_blank');
  };
  const RenderPaymentTable = () => {
    if (!paymentRec?.[0]?.payments?.length) return null;

    return (
      <ScrollView style={{ maxHeight: 350 }}>
        {paymentRec[0].payments.map((item, index) => (
          <View key={index} style={styles.paymentCard}>
            {/* Left Side */}
            <View style={styles.leftSection}>
              <Text style={styles.dateText}>
                {item?.date || "-"}
              </Text>

              <View
                style={[
                  styles.statusBadge,
                  {
                    backgroundColor: item.paid
                      ? themeObj.feedback.success[100]
                      : themeObj.feedback.error[100],
                    textAlign: 'center',
                    marginTop: 6
                  },
                ]}
              >
                <ODSText
                  type="xs"
                  color={
                    item?.paid
                      ? themeObj.feedback.success[600]
                      : themeObj.feedback.error[600]
                  }
                >
                  {item.paid ? "Confirmed" : "Not Confirmed"}
                </ODSText>
              </View>
            </View>

            {/* Right Side */}
            <View style={styles.rightSection}>
              <Text style={styles.amountText}>
                £{" "}
                {item?.amount
                  ? (item.amount / 100).toFixed(2)
                  : "-"}
              </Text>

              <Text style={styles.postcodeText}>
                {paymentRec[0]?.tenancy?.postcode || "-"}
              </Text>
            </View>
          </View>
        ))}
      </ScrollView>
    );
  };

  const cancelSubscription1 = () => {
    setpopUpIsVisible(false);
    buttonPressEvent("Cancel Subscription Credit Builder", "Credit Builder");
    dispatch(
      cancelSubscription(() => {
        loadData();
      })
    );
  };
  const _onContinue = () => {
    if (window?.ReactNativeWebView && isInappWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          val: {
            type: 'doctoopen_inapp',
            Url: url,
          },
        })
      );
    } else {
      window.open(url, '_blank');
    }
  }
  const onUpgrade = () => {
    buttonPressEvent("Subscribe to Credit Builder", "Credit Builder");
    dispatch(
      startPayment((response) => {
        if (window?.ReactNativeWebView && isMobilePaymentRequire) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              val: {
                type: 'payment',
                clientSecret: response?.clientSecret,
              },
            })
          );
        } else {
          setClientSecret(response.clientSecret);
          if (currentPlanName == 'tlyfe-extra') {
            dispatch(
              cancelRewardSubscription(true, (response) => {
              })
            );
          }
          setTimeout(
            function () {
              setShowCheckOutForm(true);
            }.bind(this),
            1000
          );
        }
      })
    );
  }

  const _signUp = () => {
    if (clhData?.payment_required || clhData?.subscription?.status == "canceled") {
      buttonPressEvent("Subscribe to Credit Builder", "Credit Builder");
      dispatch(
        startPayment((response) => {
          if (window?.ReactNativeWebView && isMobilePaymentRequire) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                val: {
                  type: 'payment',
                  clientSecret: response?.clientSecret,
                },
              })
            );
          } else {
            setClientSecret(response.clientSecret);
            if (currentPlanName == 'tlyfe-extra') {
              dispatch(
                cancelRewardSubscription(true, (response) => {
                })
              );
            }
            setTimeout(
              function () {
                setShowCheckOutForm(true);
              }.bind(this),
              1000
            );
          }
        })
      );
    } else {
      if (window?.ReactNativeWebView && isInappWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            val: {
              type: 'doctoopen_inapp',
              Url: url,
            },
          })
        );
      } else {
        window.open(url, '_blank');
      }
    }
  };

  const handleActivateFreePlan = () => {
    setIsActivating(true);
    dispatch(activateFreeCLPlan((status, message) => {
      setIsActivating(false);
      if (status) {
        setPlanActivatedSuccess(true);
      } else {
        alert(message || "Activation Failed");
      }
    }));
  };

  const renderPayments = () => {
    return (
      showCheckOutForm == 'success' ? (
        renderPaymentSuccess()
      ) : showCheckOutForm == 'failed' ? (
        renderPaymentSuccess()
      ) : (
        <Wrapper>
          <View style={{ flexDirection: 'column', width: layoutType == 'phone' ? '100%' : 400 }}>
            <ODSText marginTop={24} textAlign='center' marginBottom={12} type='h4' color={themeObj.text.primary}>Current Plan : {currentPlanName}</ODSText>
            <ODSText marginTop={12} textAlign='center' marginBottom={12} type='h4' color={themeObj.text.primary}>You selected:</ODSText>
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <PlanCard
                {...tlyfePremiumObj}
                type='single'
              />
            </View>
            <ODSText
              textAlign={'flex-start'}
              color={themeObj.neutral[700]}
              type={'button'}
              marginVertical={20}
            >
              Checkout
            </ODSText>

            {/* <View
              style={{
                padding: 24,
                borderColor: '#1B8A8C',
                borderWidth: 1.3,
                borderRadius: 8,
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <ODSText color={themeObj.neutral[700]} type={'sm'}>
                  Credit Builder
                </ODSText>
                <ODSText color={themeObj.neutral[700]} type={'sm'}>
                  £8 (inc. VAT)
                </ODSText>
              </View>
              <ODSText
                textAlign={'flex-start'}
                color={themeObj.neutral[700]}
                style={{ marginTop: 10 }}
                marginTop={20}
                type={'button'}
              >
                Total cost: £{tlyfePremiumObj?.originalPrice}
              </ODSText>
            </View> */}
            <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>
              <CheckoutForm
                theme={themeObj.main.blue}
                onSuccessToken={(success) => {
                  if (success) {

                    setShowCheckOutForm('success');
                  } else {
                    setShowCheckOutForm('failed');
                    dispatch({ type: types.SHOW_ALERT, alertType: "error", text: "Payment Failed" });
                  }
                }}
              />
            </Elements>
          </View>
        </Wrapper>
      )
    );
  };
  const renderPaymentSuccess = () => {
    return (
      <View
      >
        <View style={{ alignSelf: 'center' }}>
          {showCheckOutForm == 'success' ? <ODSIcon color={themeObj.feedback.contrast} icon={'TB-Check-Circle'} size={60} /> : <ODSIcon color={themeObj.feedback.error[500]} icon={'TB-Close'} size={60} />}
        </View>
        <ODSText marginTop={12} textAlign={'center'} color={themeObj.text.primary} type={'md-bold'}>
          {showCheckOutForm == 'success' ? 'Plan updated successfully!' : 'Payment Failed'}
        </ODSText>
        <ODSText marginTop={12} type={'md'} textAlign={'center'} color={themeObj.text.primary}>
          {showCheckOutForm == 'success' ? 'Your payment is being applied to your account, please check again in a few moments.' : 'You order has failed unfortunately.Try again.'}
        </ODSText>
        <ODSButton
          restStyle={{ marginVertical: 20, width: '80%', alignSelf: 'center' }}
          type="secondary"
          disabled={false}
          onPress={() => {
            showCheckOutForm == 'success' ?
              dispatch(
                getPaymentStatus((cb) => {
                  if (cb) {
                    setShowCheckOutForm(false);
                    loadData();
                  }
                })
              ) : setShowCheckOutForm(false)
          }}
        >
          {showCheckOutForm == "success" ? 'Refresh' : 'Retry'}
        </ODSButton>

      </View>
    );
  };
  const renderPaymentFailed = () => {
    return (
      <View
        style={{
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Image
          source={require('./../../assets/images/failed.png')}
          resizeMode="contain"
          style={{
            height: 50,
            width: 50,
            alignSelf: 'center',
            marginTop: 25,
          }}
        />
        <ODSText
          textAlign={'center'}
          color={themeObj.neutral[700]}
          style={{ alignSelf: 'center' }}
          type={'button'}
        >
          Payment failed!
        </ODSText>
        <Typography
          align={'center'}
          top={'10px'}
          size={'20px'}
          bold={'900'}
          color={COLORS.BLACK}
        ></Typography>
        <ODSText
          textAlign={'center'}
          color={themeObj.neutral[700]}
          style={{ alignSelf: 'center' }}
          type={'sm'}
        >
          Ooops! There appears to be a problem, your payment has failed.
        </ODSText>
        <ODSButton
          lIcon={'TB-Rotating'}
          restStyle={{ marginTop: 20, alignSelf: "center" }}
          type={"secondary"}
          disabled={false}
          onPress={() => setShowCheckOutForm(false)}
        >
          Try again
        </ODSButton>
      </View>
    );
  };
  const renderHowitwORKS = () => {
    return (
      <CardBig>
        <ODSText textAlign={'flex-end'} color={themeObj.neutral[700]} type={'button'}>
          How it works
        </ODSText>
        <View
          style={{
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <View
            style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <View
              style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: '#CCE8CB',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image
                source={require('../../assets/images/Vector1.png')}
                style={{
                  width: 30,
                  height: 30,
                  resizeMode: 'contain',
                }}
              />
            </View>
            <View
              style={{
                width: 3,
                height: layoutType == 'web' ? 50 : layoutType == 'phone' ? 50 : 80,
                marginVertical: 5,
                backgroundColor: COLORS.LGREEN,
              }}
            />
            <View
              style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: '#CCE8CB',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image
                source={require('../../assets/images/Vector2.png')}
                style={{
                  width: 30,
                  height: 30,
                  resizeMode: 'contain',
                }}
              />
            </View>
            <View
              style={{
                width: 3,
                height: layoutType == 'web' ? 50 : layoutType == 'phone' ? 50 : 80,
                marginVertical: 5,
                backgroundColor: COLORS.LGREEN,
              }}
            />
            <View
              style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: '#CCE8CB',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image
                source={require('../../assets/images/Vector3.png')}
                style={{
                  width: 30,
                  height: 30,
                  resizeMode: 'contain',
                }}
              />
            </View>
          </View>
          <View
            style={{
              width: layoutType == 'web' ? '85%' : layoutType == 'phone' ? '75%' : '80%',
            }}
          >
            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={layoutType == 'phone' ? 10 : 30}
              type={'sm'}
            >
              Provide your tenancy details
            </ODSText>

            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={10}
              type={'sm'}
            >
              {`Confirm your identity and tenancy details by answering a few quick questions. This will allow future rent payments to be reported to all three major credit agencies.`}
            </ODSText>

            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={layoutType == 'phone' ? 10 : 30}
              type={'sm'}
            >
              Connect your bank for read-only access
            </ODSText>

            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={10}
              type={'sm'}
            >
              The rent reporting service is FCA regulated and the technology we use is supported by
              all major banks.
            </ODSText>

            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={layoutType == 'phone' ? 10 : 30}
              type={'sm'}
            >
              Pay your rent as normal
            </ODSText>

            <ODSText
              textAlign={'flex-end'}
              color={themeObj.neutral[700]}
              marginTop={10}
              type={'sm'}
            >
              The service will read and identify rent payments that will appear on statutory credit
              reports.
            </ODSText>
          </View>
        </View>
      </CardBig>
    );
  };
  const calculateDaysLeft = (status, voluntaryChurnAt) => {
    if (status === "voluntary_churn" || status === "ended") {
      const voluntaryChurnDate = new Date(voluntaryChurnAt);
      const allowedDate = new Date(voluntaryChurnDate);
      allowedDate.setDate(voluntaryChurnDate.getDate() + 90);

      const today = new Date();
      const timeDiff = allowedDate - today;
      const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      return daysLeft > 0 ? daysLeft : 0;
    }
    return null;
  };
  const updateSubscription = () => {
    let getBaseURL = getServerURL();
    let redirect_url =
      `${getBaseURL}/${layoutType === "web" ? "my-account/subscriptions" : "myaccount/invoice"}`;
    window.open(redirect_url, '_self');
    // let getBaseURL=getServerURL();
    // let redirect_url = 
    // `${getBaseURL}/credit-builder`;
    // dispatch(
    //     updatePayment(redirect_url,(response) => {
    //         console.log("___",response)
    //         window.open(response?.url,'_self');
    //     })
    //   );

  }
  const isSuscribed = () => {
    return clhData?.subscription?.status == 'active' ? true : false;
  };

  const renderStatusView = () => {
    const isSelectedForFreeCL = clhData?.user_data?.is_selected_for_free_cl || clhData?.is_selected_for_free_cl;
    const isFreeCLActivated = clhData?.user_data?.is_free_cl_activated || clhData?.is_free_cl_activated;
    const hasActiveSubscription = subscription && subscription.status !== 'canceled';

    if (planActivatedSuccess) {
      return (
        <View style={{ alignItems: 'center', padding: 20 }}>
          <View style={{ padding: 10, marginVertical: 12, borderRadius: 100, alignSelf: 'center', backgroundColor: themeObj.feedback.success[500] }}>
            <ODSIcon icon='TB-Check-Circle' color='white' size={24} />
          </View>
          <ODSText textAlign='center' color={themeObj.text.primary} type='md-bold'>
            Plan activated successfully!
          </ODSText>
          <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={10}>
            Your Credit Builder Lite Plan is being applied to your account, please check again in a few moments.
          </ODSText>
          <ODSButton
            restStyle={{ width: 300, marginTop: 20, alignSelf: 'center' }}
            type="secondary"
            onPress={() => {
              setPlanActivatedSuccess(false);
              loadData();
            }}
          >
            Refresh
          </ODSButton>

        </View>
      );
    }

    if (isSelectedForFreeCL && !hasActiveSubscription) {
      if (!isFreeCLActivated) {
        return (
          <View style={{ alignItems: 'center' }}>
            <ODSText textAlign='center' type='h5' color={themeObj.main.blue[500]} marginTop={10}>
              Congratulations!
            </ODSText>
            <ODSText textAlign='center' type='md-bold' color={themeObj.text.primary} marginTop={10} style={{ fontWeight: 'bold' }}>
              You have been selected to receive {"\n"} FREE {"\n"} Credit Builder <ODSText color={'#EB3754'} type='md-bold'>Lite</ODSText>
            </ODSText>
            <ODSButton
              restStyle={{ width: '80%', marginTop: 20, alignSelf: 'center' }}
              type="primary"
              onPress={handleActivateFreePlan}
              loading={isActivating}
            >
              Activate FREE Plan
            </ODSButton>
            <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
              Credit Builder Lite gives you access to all {"\n"} credit builder functionalities with communication to {"\n"} <Text style={{ color: '#EB3754', fontWeight: 'bold' }}>ONE Credit Reference Agency (CRA).</Text>
            </ODSText>
            <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
              If you need to communicate your payments {"\n"} to <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>more than one entity</Text> you need to {"\n"} <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>subscribe to tlyfe Premium</Text>
            </ODSText>

            <View style={{ marginTop: 20, width: '100%', alignItems: 'center' }}>
              {tlyfePremiumObj && (
                <PlanCard
                  {...tlyfePremiumObj}
                  type='single'
                >
                  <View style={[styles.featuresContainer, { borderWidth: 1, borderColor: getItemColor(tlyfePremiumObj.id).borderColor }]}>
                    {tlyfePremiumObj.features.map((feature, index) => (
                      <View key={index} style={styles.featureRow}>
                        <ODSText type='h6' marginRight={8} >•</ODSText>
                        <ODSText type='xs' flex={1}>{feature.text}</ODSText>
                      </View>
                    ))}
                  </View>
                  <ODSButton
                    restStyle={{ width: '80%', marginTop: 20, alignSelf: 'center' }}
                    type="primary"
                    themeColor={themeObj.main.purple}
                    onPress={onUpgrade}
                  >
                    Upgrade
                  </ODSButton>
                </PlanCard>
              )}
            </View>

            <View style={{ marginTop: 20 }}>
              <Image
                source={require('../../../openbrix-design-system/images/banner/mobile/trustpilot.png')}
                style={{
                  width: 400,
                  height: 80,
                  resizeMode: 'contain',
                  alignSelf: 'center',
                }}
              />
            </View>


          </View>
        );
      } else {
        const isConnected = clhData?.connected;


        if (!isConnected) {
          return (
            <View>
              <View style={{ padding: 5, marginVertical: 12, borderRadius: 100, alignSelf: 'center', backgroundColor: themeObj.theme.yellow }}>
                <ODSIcon icon='TB-Rotating' color='white' size={24} />
              </View>
              <ODSText textAlign='center' color={themeObj.text.primary} style={{ alignSelf: 'center', fontWeight: 'bold' }} type='md'>
                Connect to OpenBanking
              </ODSText>
              <ODSText textAlign='center' color={themeObj.neutral[700]} marginTop={10} style={{ alignSelf: 'center' }} type='sm'>
                Please click continue, to complete your {"\n"} application and begin rent reporting.
              </ODSText>
              <ODSButton restStyle={{ width: '80%', marginTop: 20, alignSelf: 'center' }} type='secondary' themeColor={themeObj.main.gold} disabled={!url} onPress={_onContinue}>
                Continue
              </ODSButton>

            </View>
          );
        } else {
          return (
            <View style={{ alignItems: 'center' }}>
              <ODSText textAlign='center' type='button' color={themeObj.text.primary} type='md-bold' marginTop={10}>
                You're currently on the {"\n"} Credit Builder Lite Plan!
              </ODSText>
              <ODSButton
                restStyle={{ width: '80%', marginTop: 20, alignSelf: 'center' }}
                type="primary"
                // themeColor={'#1B8A8C'}
                onPress={_onContinue}
              >
                Manage My Credit Builder
              </ODSButton>
              <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
                Credit Builder Lite gives you access to all {"\n"} credit builder functionalities with {"\n"} <Text style={{ color: themeObj.text.black, fontWeight: 'bold' }}>communication to one entity.</Text>
              </ODSText>
              <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
                If you need to communicate your payments {"\n"} to <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>more than one entity</Text> you need to {"\n"} <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>subscribe to tlyfe Premium</Text>
              </ODSText>
              <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
                Credit Builder Lite gives you access to all {"\n"} credit builder functionalities with communication to {"\n"} <Text style={{ color: '#EB3754', fontWeight: 'bold' }}>ONE Credit Reference Agency (CRA).</Text>
              </ODSText>
              <ODSText textAlign='center' color={themeObj.neutral[700]} type='sm' marginTop={20}>
                If you need to communicate your payments {"\n"} to <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>more than one entity</Text> you need to {"\n"} <Text style={{ fontWeight: 'bold', color: themeObj.text.black }}>subscribe to tlyfe Premium</Text>
              </ODSText>

              <View style={{ marginTop: 20, width: '100%', alignItems: 'center' }}>
                {tlyfePremiumObj && (
                  <PlanCard
                    {...tlyfePremiumObj}
                    type='single'
                  >
                    <View style={[styles.featuresContainer, { borderWidth: 1, borderColor: getItemColor(tlyfePremiumObj.id).borderColor }]}>
                      {tlyfePremiumObj.features.map((feature, index) => (
                        <View key={index} style={styles.featureRow}>
                          <ODSText type='h6' marginRight={8} >•</ODSText>
                          <ODSText type='xs' flex={1}>{feature.text}</ODSText>
                        </View>
                      ))}
                    </View>
                    <ODSButton
                      restStyle={{ width: '80%', marginTop: 20, alignSelf: 'center' }}
                      type="primary"
                      themeColor={themeObj.main.purple}
                      onPress={onUpgrade}
                    >
                      Upgrade
                    </ODSButton>
                  </PlanCard>
                )}
              </View>


            </View>
          );
        }
      }
    }

    return (
      <View>
        {isSuscribed() ? (clhData?.user_data?.status == 'pending' ||
          clhData?.user_data?.status == 'accepted' ||
          clhData?.user_data?.status == 'live' ? (
          <ODSText
            textAlign={'center'}
            color={themeObj.text.primary}
            style={{ alignSelf: 'center' }}
            type={'button'}
          >
            You’re currently subscribed!
          </ODSText>
        ) : (
          <>
            <View style={{ padding: 5, marginVertical: 12, borderRadius: 100, alignSelf: 'center', backgroundColor: themeObj.theme.yellow }}>
              <ODSIcon icon='TB-Rotating' color='white' size={24} />
            </View>
            <ODSText
              textAlign={'center'}
              color={themeObj.neutral[700]}
              style={{ alignSelf: 'center' }}
              type={'button'}
            >
              Connect to OpenBanking
            </ODSText>
            <ODSText
              textAlign={'center'}
              color={themeObj.neutral[700]}
              marginTop={10}
              style={{ alignSelf: 'center' }}
              type={'sm'}
            >
              Please click continue, to complete your application and begin rent
              reporting.
            </ODSText>
          </>
        )
        ) : (
          <ODSText marginTop={8} textAlign={'center'} color={themeObj.neutral[700]} type={'button'}>
            Please subscribe to premium to unlock this feature.
          </ODSText>
        )}
        <ODSButton
          restStyle={{ width: 300, marginTop: 20, alignSelf: 'center' }}
          type={
            (subscription && subscription?.status != 'canceled') ?
              (clhData?.user_data?.status == 'pending' ||
                clhData?.user_data?.status == 'accepted' ||
                clhData?.user_data?.status == 'live')
                ? 'primary'
                : 'secondary' : 'primary'
          }
          themeColor={
            (subscription && subscription?.status != 'canceled') ?
              (clhData?.user_data?.status == 'pending' ||
                clhData?.user_data?.status == 'accepted' ||
                clhData?.user_data?.status == 'live')
                ? themeObj.main.blue
                : themeObj.main.gold : themeObj.main.blue
          }
          disabled={!clhData?.payment_required && !url}
          onPress={_signUp}
        >
          {clhData?.user_data?.status == 'pending' ||
            clhData?.user_data?.status == 'accepted' ||
            clhData?.user_data?.status == 'live'
            ? 'Manage my Credit Builder'
            : (subscription && clhData?.subscription?.status != "canceled")
              ? 'Continue'
              : `Subscribe`}
        </ODSButton>
        {clhData?.user_data?.status == 'pending' ||
          clhData?.user_data?.status == 'accepted' ||
          clhData?.user_data?.status == 'live'
          ? null
          : (subscription && clhData?.subscription?.status != "canceled")
            ? null :
            <Image
              source={require('../../../openbrix-design-system/images/banner/mobile/trustpilot.png')}
              style={{
                width: '100%',
                height: 120,
                resizeMode: 'contain',
                alignSelf: 'center',
                marginTop: 20
              }}
            />
        }
        {(subscription && clhData?.subscription?.status != "canceled") && (
          <ODSText
            textAlign={'center'}
            color={themeObj.neutral[700]}
            marginTop={10}
            style={{ alignSelf: 'center' }}
            type={'sm'}
          >
            Subscription renews :{' '}
            {
              new Date(subscription?.current_period_end * 1000)
                .toISOString()
                .split('T')[0]
            }
          </ODSText>
        )}
        {(subscription && clhData?.user_data?.status == 'pending' ||
          clhData?.user_data?.status == 'accepted' ||
          clhData?.user_data?.status == 'live') && (
            <>
              <ODSText
                textAlign={'center'}
                color={themeObj.neutral[700]}
                marginTop={10}
                style={{ alignSelf: 'center' }}
                type={'sm'}
              >
                Payment Method :{' '}
                xxxx xxxx xxxx {clhData?.cl_payment_method?.card?.last4}
              </ODSText>
              <ODSButton
                restStyle={{ width: 300, marginTop: 20, alignSelf: 'center' }}
                type="primary"
                onPress={updateSubscription}
              >
                Update Payment Method
              </ODSButton>
            </>
          )}

        {(subscription && clhData?.subscription?.status != "canceled" && clhData?.user_data?.status !== 'ended') ? (
          <>
            <ODSButton
              restStyle={{ width: 300, marginTop: 20, alignSelf: 'center' }}
              type="secondary"
              themeColor={themeObj.main.red}
              onPress={updateSubscription}
            >
              Cancel Subscription
            </ODSButton>
          </>
        ) : null}

      </View>
    )
  }
  const checkVoluntaryChurn = calculateDaysLeft(clhData?.user_data?.status, clhData?.user_data?.voluntary_churn_at);

  const renderVoluntaryChurnView = () => {
    return (
      <View>
        <ODSText
          textAlign={'center'}
          color={themeObj.text.primary}
          style={{ alignSelf: 'center' }}
          marginTop={10}
          type={'button'}
        >
          Unfortunately you cannot resubscribe to this service yet.
        </ODSText>
        <ODSText
          textAlign={'center'}
          color={themeObj.text.primary}
          align='center'
          marginTop={10}
          type='sm'
        >
          You voluntarily canceled your subscription on the {moment(clhData?.user_data?.voluntary_churn_at).format('DD-MM-YYYY')}. You will be able to resubscribe {checkVoluntaryChurn} days.
        </ODSText>

        <ODSText
          textAlign={'left'}
          marginTop={20}
          color={themeObj.neutral[700]}
          style={{ alignSelf: 'left' }}
          type={'md'}>
          Supported banks:
        </ODSText>

        <ODSText
          textAlign={'left'}
          color={themeObj.neutral[700]}
          marginTop={10}
          style={{ alignSelf: 'center' }}
          type={'sm'}>
          {`Bank of Scotland, Barclays, Chelsea Building Society, Chase, Danske Bank, First Direct, Halifax, HSBC, Lloyds Bank, MBNA, Monzo, Nationwide, Natwest, Revolut, Royal Bank of Scotland, Santander, Starling Bank, Tesco Bank, Tide, Transferwise, TSB, Ulster Bank, Yorkshire Building Society`}
        </ODSText>

      </View>
    )
  }

  return (
    <BackGroundGenerator isTLYF props={props}>
      <ImageBackground
        source={getImage('cb.png')}
        style={{
          width: '100%',
          height: '270px',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
        resizeMode="cover"
      >
        {authDataFromMobile ? null : (
          <ODSButton
            rIcon={'TB-Arrow-Left'}
            restStyle={{ marginTop: 20, marginLeft: 20, width: 200 }}
            type="secondary"
            disabled={false}
            onPress={() => replaceAction(props?.navigation, 'Dashboard')}
          >
            My Dashboard
          </ODSButton>
        )}
      </ImageBackground>
      {showCheckOutForm == true ? (
        renderPayments()
      ) : (
        <RowContainer>
          <View>
            <CardBig>
              <ODSText textAlign={'flex-end'} color={themeObj.neutral[700]} type={'button'}>
                Report your rent payments to help improve your credit score
              </ODSText>
              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={10}
                type={'sm'}
              >
                The smarter way to report your rent payments & improve your credit position
                with the UK’s top three credit reference agencies: Experian, Equifax and TransUnion.
              </ODSText>
              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={10}
                type={'xs'}
              >
                {`*Our Rent Reporting function allows you to keep and prove that your rent payment are up to date and with tlyfe sharing these payments with the Credit Reference Agencies, your prompt rental payments can influence your own Credit Score.`}
              </ODSText>

              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={20}
                type={'button'}
              >
                Benefit from Credit Building
              </ODSText>
              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={10}
                type={'sm'}
              >
                A credit score forms the basis on which companies make lending decisions. A strong
                credit rating can help you access finance at better rates.
              </ODSText>

              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={20}
                type={'button'}
              >
                Benefit from Rent Reporting
              </ODSText>
              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={10}
                type={'sm'}
              >
                A verified record that shows your rental payments are made in full and on time,
                which you can share with agents, landlords or mortgage lenders.
              </ODSText>
              <ODSText
                textAlign={'flex-end'}
                color={themeObj.neutral[700]}
                marginTop={10}
                type={'sm'}
              >
                Sign up and start building your credit profile for only{' '}
                <ODSText textAlign={'flex-end'} color={themeObj.neutral[700]} type={'button'}>
                  £8.00 per month.
                </ODSText>
                Click the button below.
              </ODSText>
            </CardBig>
            {renderHowitwORKS()}
          </View>
          <View>
            <CardBig>
              <>
                {showCheckOutForm == 'success' ? (
                  renderPayments()
                ) : (
                  checkVoluntaryChurn ? renderVoluntaryChurnView() : renderStatusView()
                )}
              </>

              {paymentRec && paymentRec?.length ? (
                <View>
                  <View
                    style={{ flexDirection: 'row', justifyContent: 'space-around', marginTop: 20 }}
                  >
                    <TabHeadingText style={{ color: "black", marginBottom: 10 }}>Payment History</TabHeadingText>
                  </View>

                  <View
                    style={{
                      height: 1,
                      backgroundColor: '#D9D9D9',
                      width: '100%',
                    }}
                  />
                  {RenderPaymentTable()}
                  <ODSButton
                    rIcon={'TB-Share'}
                    restStyle={{ marginTop: 20, alignSelf: 'center', width: 300 }}
                    type="secondary"
                    disabled={false}
                    onPress={() => props.navigation.navigate('Document Share Center', { activeIndex: 2 })}
                  >
                    My Share Centre
                  </ODSButton>
                  <ODSButton
                    restStyle={{ marginTop: 20, alignSelf: 'center', width: 300 }}
                    type="primary"
                    disabled={false}
                    onPress={() => {
                      dispatch(getLadgerHistory((data) => {
                        window.open(
                          data,
                          '_blank' // <- This is what makes it open in a new window.
                        );
                      }))
                    }}
                  >
                    Download Rent Record
                  </ODSButton>
                </View>
              ) : <>
                <View
                  style={{
                    height: 1,
                    backgroundColor: '#D9D9D9',
                    width: '100%',
                    marginTop: 16
                  }}
                />
                <TabHeadingText style={{ color: "black", marginTop: 30 }}>Payment History</TabHeadingText>
                <ODSText textAlign='center' color={themeObj.text.primary} type='md' marginVertical={12}>You have no rent payments yet.</ODSText>
              </>}
              {/* <Image
                source={require('../../assets/images/clbanner.png')}
                style={{
                  width: 213,
                  height: 100,
                  resizeMode: 'contain',
                  alignSelf: 'center',
                  marginTop: 20,
                }}
              /> */}

              <ODSText
                textAlign={'flex-start'}
                color={themeObj.neutral[700]}
                marginTop={10}
                style={{ alignSelf: 'center' }}
                type={'sm'}
              >
                Supported banks:
              </ODSText>

              <ODSText
                textAlign={'flex-start'}
                color={themeObj.neutral[700]}
                marginTop={10}
                style={{ alignSelf: 'center' }}
                type={'sm'}
              >
                {`Bank of Scotland, Barclays, Chelsea Building Society, Chase, Danske Bank, First Direct, Halifax, HSBC, Lloyds Bank, MBNA, Monzo, Nationwide, Natwest, Revolut, Royal Bank of Scotland, Santander, Starling Bank, Tesco Bank, Tide, Transferwise, TSB, Ulster Bank, Yorkshire Building Society`}
              </ODSText>
            </CardBig>
          </View>
        </RowContainer>
      )}
      <CustomPopUp
        loading={popUpIsVisible}
        primaryButtonText={'Sure'}
        secondaryButtonText={'Back'}
        primaryText={'Cancel Subscriptions ?'}
        secondaryText={' Are you sure you want to Cancel Subscriptions?'}
        onPrimaryButtonPress={() => {
          cancelSubscription1();
        }}
        note={
          'that by cancelling this product your monthly rent will not be recorded on your credit file with UK largest credit reference agencies. Many banks and financial institutions use these agencies when giving you credit and loans. This can materially impact your interest on credit cards and loans. Furthermore due to open banking regulation, once cancelled we would require 45 days to reconnect to your bank.'
        }
        onSecondaryButtonPress={() => {
          setpopUpIsVisible(false);
        }}
      />
    </BackGroundGenerator>
  );
};
export default MoreInformation;
const styles = StyleSheet.create({
  paymentCard: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E5E5",
  },

  leftSection: {
    justifyContent: "center",
  },

  rightSection: {
    alignItems: "flex-end",
    justifyContent: "center",
  },

  dateText: {
    fontSize: 18,
    fontWeight: "700",
    color: "#1C1C1C",
  },
  featuresContainer: {
    marginVertical: 12,
    minHeight: 120,
    backgroundColor: 'white',
    padding: 16,
    borderRadius: 12
  },
  featureRow: {
    flexDirection: 'row',
    marginBottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },

  statusText: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 4,
  },

  amountText: {
    fontSize: 18,
    fontWeight: "700",
    color: "#1C1C1C",
  },

  postcodeText: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 4,
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
  },
});
